/* Claude PDP — app-proof add-to-cart. Adds via /cart/add.js directly so app scripts (STOQ etc.) can't dead-end the button. Also emits standard variant-change signals for app widgets. */
(function(){
  function init(){
    var form = document.getElementById('cp-form');
    var atc = document.getElementById('cp-atc');
    if (!form || !atc) return;
    function doAdd(e){
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (atc.disabled) return;
      var idEl = form.querySelector('input[name="id"]');
      var spEl = form.querySelector('input[name="selling_plan"]');
      var payload = { id: parseInt(idEl.value, 10), quantity: 1 };
      if (spEl && spEl.value) payload.selling_plan = parseInt(spEl.value, 10);
      atc.disabled = true;
      var oldTxt = atc.textContent;
      atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(r){
        if (r.ok) { window.location.href = '/cart'; }
        else {
          return r.json().then(function(j){
            atc.disabled = false; atc.textContent = oldTxt;
            alert((j && (j.description || j.message)) || 'Could not add to cart — please call 1-888-651-3091.');
          });
        }
      }).catch(function(){
        atc.disabled = false; atc.textContent = oldTxt;
        form.submit();
      });
    }
    // Capture-phase click so no later-registered app handler can swallow it
    atc.addEventListener('click', doAdd, true);
    form.addEventListener('submit', doAdd, true);
    // Broadcast variant changes in the ways app widgets expect
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      var mo = new MutationObserver(function(){ notify(); });
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    window.cpNotifyVariant = notify;
    function notify(){
      var idEl = form.querySelector('input[name="id"]');
      if (!idEl || !idEl.value) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', idEl.value);
        history.replaceState({}, '', u.toString());
      } catch(err){}
      idEl.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { id: idEl.value } }));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Accessibility: give every spec table a (visually hidden) caption */
(function(){
  function addCaptions(){
    var tables = document.querySelectorAll('table.cp-spec, table.cp-cmp');
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i];
      if (!t.querySelector('caption')) {
        var c = document.createElement('caption');
        c.textContent = 'Product specifications';
        c.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
        t.insertBefore(c, t.firstChild);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addCaptions);
  else addCaptions();
})();
